import vue3GoogleLogin from 'vue3-google-login'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(vue3GoogleLogin, {
    clientId: '337539770135-lgimo4qvt74ubog3mukmj278jeaamls5.apps.googleusercontent.com'
  })
})
